import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

type Props = { href: string; children?: React.ReactNode };

/**
 * 外部サイトへのリンクを新しいタブで開くリンク。末尾に外部リンクアイコンを表示する。
 */
export const ExternalLink: React.FC<Props> = ({ href, children }: Props) => (
  <a href={href} target="_blank" rel="noreferrer noopener" className="text-blue-700 underline hover:text-blue-800">
    {children} <FontAwesomeIcon icon={faExternalLinkAlt} />
  </a>
);
